import { getAuth } from "firebase/auth"
import { collection, connectFirestoreEmulator, getFirestore } from "firebase/firestore"
import FirebaseClientLogs from "../base_de_donnees/FirebaseClientLogs.js"
import FirebaseCommunautes from "../base_de_donnees/FirebaseCommunautes.js"
import FirebaseConversation from "../base_de_donnees/FirebaseConversation.js"
import FirebaseMembres from "../base_de_donnees/FirebaseMembres.js"
import FirebasePokemons from "../base_de_donnees/FirebasePokemons.js"
import FirebasePokemonsAEchanges from "../base_de_donnees/FirebasePokemonsAEchanges.js"

export default class FirebaseBaseDeDonnees {
  /** @type {import("firebase/app").FirebaseApp | null} */
  app = null

  /** @type {import("firebase/firestore").Firestore | null} */
  bdd = null

  /** @type {FirebaseClientLogs | null} */
  clientLogs = null

  /** @type {FirebaseCommunautes | null} */
  communautes = null

  /** @type {FirebaseConversation | null} */
  conversation = null

  /** @type {FirebaseMembres | null} */
  membres = null

  /** @type {FirebasePokemons | null} */
  pokemons = null

  /** @type {FirebasePokemonsAEchanges | null} */
  pokemonsAEchanges = null

  constructor(app) {
    this.app = app
    this.bdd = getFirestore(app)

    if (this.estModeLocalhost()) {
      try {
        connectFirestoreEmulator(this.bdd, "localhost", 8080)
      } catch (error) {
        console.error(error)
      }
    } else if (this.estModeRemotePhone()) {
      try {
        connectFirestoreEmulator(getFirestore(this.app), import.meta.env.VITE_IP_PHONE_EMULATEUR, 8080)
      } catch (error) {
        console.error(error)
      }
    }

    this.clientLogs = new FirebaseClientLogs(this)
    this.communautes = new FirebaseCommunautes(this)
    this.conversation = new FirebaseConversation(this)
    this.membres = new FirebaseMembres(this)
    this.pokemons = new FirebasePokemons(this)
    this.pokemonsAEchanges = new FirebasePokemonsAEchanges(this)
  }

  estModeLocalhost() {
    return typeof location !== "undefined" && location.hostname === "localhost"
  }

  estModeRemotePhone() {
    return location.hostname === import.meta.env.VITE_IP_PHONE_EMULATEUR
  }

  recupererCollection(nomCollection) {
    return collection(this.bdd, nomCollection)
  }

  recupererPseudoUtilisateurCourant() {
    return window.authentification?.getUser?.()?.displayName || ""
  }

  recupererIdUtilisateurCourant() {
    const idUtilisateur = getAuth(this.app).currentUser?.uid || window.authentification?.getUser?.()?.uid

    if (!idUtilisateur) {
      throw new Error("Utilisateur non connecte")
    }

    return idUtilisateur
  }

  async journaliserErreurEtRelancer(error, contexte) {
    console.error(contexte, error)
    await this.clientLogs.logErrorToFirebase(error, contexte, this.recupererPseudoUtilisateurCourant())
    throw error
  }
}
